import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// import { Message } from 'element-ui'
import { getUID, getUsername } from '@/utils/auth'

const whiteList = [
  '/login',
  '/goog-auth',
  '/otp',
  '/reset-password'
] // no redirect

router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    if (to.query && to.query.prefer === 'true' &&
      store.getters.referer
    ) {
      store.dispatch('setPReferer', store.getters.referer)
    } else if (store.getters.preferer) {
      from = store.getters.preferer
      store.dispatch('setPReferer', null)
    }
    store.dispatch('setReferer', from)
  }
  NProgress.start()
  const uid = getUID()
  if (uid) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger afterEach hook, so manually handle it
    } else {
      const userInfo = {
        uid: uid,
        username: getUsername()
      }
      store.dispatch('SetInfo', userInfo).then(() => {
        next()
      }).catch(() => {
        next()
      })
      if (store.getters.uid.length === 0) {
        store.dispatch('FedLogOut').then(() => {
          next({ path: '/login' })
        }).catch(() => {
          next()
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // end Progress
})
